module.exports = __webpack_public_path__ + "static/media/10.1b4dfabc.jpg";